import * as React from 'react';
import { Breadcrumbs, Link, Stack, Typography } from '@mui/material/';

export const CustomBreadCrumb = ({currentPage,parentData,seperator}) => {
  let currentBreadcrumbs = [
    <Typography key="3" color="text.primary">
      {currentPage}
    </Typography>,
  ];

  const parent = parentData?.map((child) => {
    return <Link
    underline="hover"
    key="2"
    color="inherit"
    href={child.pageLink}
  >
    {child.pageName}
  </Link>;
  });
  currentBreadcrumbs = [parent, ...currentBreadcrumbs];

  return (
    <Stack spacing={2} className='mb-16 mt-10'>
      <Breadcrumbs separator={seperator} aria-label="breadcrumb">
        {currentBreadcrumbs}
      </Breadcrumbs>
    </Stack>
  );
}